import * as React from 'react';

function SvgArrowBigLeft(props) {
  return (
    <svg width={21} height={36} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.404 3.424A2 2 0 0017.596.576l-17 16.762a2 2 0 00.07 2.913l17 15.238a2 2 0 102.669-2.978L4.919 18.692 20.404 3.424z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgArrowBigLeft;
